import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'achoo-story-preview',
  templateUrl: './achoo-story-preview.component.html',
  styleUrls: ['./achoo-story-preview.component.scss']
})
export class AchooStoryPreviewComponent implements OnInit {
  @ViewChild('videoMedia') videoMedia: ElementRef;
  @Input()
  public srcVideo: string;
  @Input()
  public posterImage: string;
  @Input()
  public isVideo: boolean;
  @Input()
  public completed: boolean;

  constructor() { }

  ngOnInit() {
  }

  toggleVideoPlayer() {
    if (!this.videoMedia) {
      return;
    }
    const method = this.videoMedia.nativeElement.paused ? 'play' : 'pause';
    this.videoMedia.nativeElement[method]();
  }

  afterEndVideo() {
    if (!this.videoMedia) {
      return;
    }
    this.videoMedia.nativeElement.parentElement.classList.remove('playing');
  }

  get isPlaying() {
    if (!this.videoMedia) {
      return false;
    }
    return !this.videoMedia.nativeElement.paused;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-story-preview/achoo-story-preview.component.ts